import React from 'react';
import './InfoFaq.scss';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import InfoFaqItem from 'Components/InfoFaq/InfoFaqItem';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';

interface IProps {
  isFetching: boolean;
  isFetchFailed: boolean;
  faqList: Julius.Website.FAQViewModel[];
}

const InfoFaq: React.SFC<IProps> = ({
  isFetching,
  isFetchFailed,
  faqList,
}) => {

  if (isFetching) {
    return null;
  }

  if (isFetchFailed) {
    return (
      <WrapperLayout style='info-faq'>
        <FetchFailureMessage />
      </WrapperLayout>
    );
  }

  return (
    <WrapperLayout style='info-faq'>
      <div className='faq-desc'>
        <FormattedText 
          style='faq-title'
          displayName='Vanliga frågor'
          formattedName='info.faq.header'
        />
        <FormattedText 
          style='faq-sub-title'
          displayName='Vår support har samlat de vanligaste frågorna. Finner du inte ditt svar är du såklart välkommen att kontakta oss.'
          formattedName='info.faq.text'
        />
        <Button style='button-contact' localPath='/information/kontakt'>
          <Icon type='arrow-up' />
          <FormattedText
            displayName='Till kontakta oss'
            formattedName='info.faq.button.contact'
          />
        </Button>
      </div>
      <div className='faq-list'>
        { faqList.map((f, i) => <InfoFaqItem key={ i } { ...f } /> ) }
      </div>
    </WrapperLayout>
  );
};

export default InfoFaq;


// WEBPACK FOOTER //
// ./src/components/InfoFaq/InfoFaq.tsx